var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmationModal',{attrs:{"bodyText":"","continueText":"confirm","headerText":_vm.errorHeader,"mainActionAttention":true}},[_c('div',{class:_vm.$style.errorContent},[_vm._v(" "+_vm._s(_vm.errorText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }